import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { SelectOptionLoaderI } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-select/models/select-option-loader-i';
import { SpecFieldNames } from '@ordersnproducts/modules/order-builder/modules/specification/constants/specification-field-names.enum';
import { SelectOptionI } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-select/models/select-option-i';
import { OrderBuilderState } from '@ordersnproducts/modules/order-builder/reducers/index';
import { getOpenPlatformAvailablePaymentTerms } from '@ordersnproducts/modules/order-builder/modules/rms-specification/selectors/contracts.selectors';

@Injectable()
export class PaymentTermsOptionLoaderOpenPlatformService implements SelectOptionLoaderI {
  constructor(private store: Store<OrderBuilderState>) {}

  /**
   * Provides an observable of paymentTerms
   * @return {Observable<SelectOptionI[]>}
   */
  loadOptions(formGroup: UntypedFormGroup): Observable<SelectOptionI[]> {
    return this.store.pipe(
      select(getOpenPlatformAvailablePaymentTerms),
      filter((data) => !!data),
      map((availablePaymentTerms) => {
        const contractCode = formGroup.get(SpecFieldNames.CONTRACT_SELECT).value;
        if (availablePaymentTerms && availablePaymentTerms.length && contractCode) {
          formGroup.get(SpecFieldNames.PAYMENT_TERMS).setValue(availablePaymentTerms[0].paymentTermCode);
          return availablePaymentTerms.map((paymentTerm) => {
            return {
              id: paymentTerm.paymentTermCode,
              name: `${paymentTerm.paymentTermDesc}`,
            };
          });
        }
        return [];
      }),
    );
  }
}
